import { useEffect, useState } from "react";

export const notifySupported = () => typeof window !== "undefined" && "Notification" in window;
export const notifyPermission = () => (notifySupported() ? Notification.permission : "unsupported");

export async function requestNotifications() {
  if (!notifySupported()) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  return Notification.requestPermission();
}

export const inBackground = () => document.visibilityState === "hidden" || !document.hasFocus();

// System notification via the service worker (works while the tab/app window is minimized or behind other apps).
export async function showOrderNotification({ title, body, tag, url = "/app/restaurant/orders" }) {
  if (notifyPermission() !== "granted") return false;
  const opts = { body, tag, renotify: true, icon: "/icons/icon-192.png", badge: "/icons/icon-192.png", data: { url }, requireInteraction: true, vibrate: [200, 100, 200] };
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) { await reg.showNotification(title, opts); return true; }
  } catch { /* fall through */ }
  try { const n = new Notification(title, opts); n.onclick = () => { window.focus(); n.close(); }; return true; } catch { return false; }
}

export function useNotifyPermission() {
  const [perm, setPerm] = useState(notifyPermission);
  useEffect(() => {
    if (!navigator.permissions?.query) return undefined;
    let status;
    navigator.permissions.query({ name: "notifications" }).then((s) => { status = s; s.onchange = () => setPerm(notifyPermission()); }).catch(() => {});
    return () => { if (status) status.onchange = null; };
  }, []);
  const request = async () => { const p = await requestNotifications(); setPerm(p); return p; };
  return { perm, request, supported: notifySupported() };
}
